import script from "./WithdrawList.vue?vue&type=script&setup=true&lang=js"
export * from "./WithdrawList.vue?vue&type=script&setup=true&lang=js"

import "./WithdrawList.vue?vue&type=style&index=0&id=63ea6670&lang=scss&scoped=true"

import exportComponent from "/www/wwwroot/192.255.151.37/new/tiempos-h55/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63ea6670"]])

export default __exports__